var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "base-action-button" },
    [
      _vm.hasTooltip
        ? _c(
            "v-tooltip",
            {
              staticClass: "base-action-button__tooltip-wrapper",
              attrs: { top: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function(ref) {
                      var on = ref.on
                      var attrs = ref.attrs
                      return [
                        _c(
                          "span",
                          _vm._g(
                            _vm._b(
                              { class: _vm.wrapperClassList },
                              "span",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _vm.iconOnly
                              ? _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        staticClass:
                                          "base-action-button__icon-button",
                                        attrs: {
                                          icon: "",
                                          loading: _vm.isLoading,
                                          disabled: _vm.isDisabled
                                        }
                                      },
                                      "v-btn",
                                      _vm.$attrs,
                                      false
                                    ),
                                    _vm.$listeners
                                  ),
                                  [
                                    _vm.resolvedIconName
                                      ? _c("icon-svg", {
                                          class: _vm.iconClassList,
                                          attrs: {
                                            name: _vm.resolvedIconName,
                                            color: _vm.resolvedIconColor
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _c(
                                  "BaseButton",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        attrs: {
                                          loading: _vm.isLoading,
                                          disabled: _vm.isDisabled
                                        }
                                      },
                                      "BaseButton",
                                      _vm.$attrs,
                                      false
                                    ),
                                    _vm.$listeners
                                  ),
                                  [
                                    _vm.resolvedIconName
                                      ? _c("icon-svg", {
                                          class: _vm.iconClassList,
                                          attrs: {
                                            name: _vm.resolvedIconName,
                                            color: _vm.resolvedIconColor
                                          }
                                        })
                                      : _vm._e(),
                                    _vm.label
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "base-action-button__label"
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(_vm.label) + " "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ],
                null,
                false,
                1503425018
              )
            },
            [_c("span", [_vm._v(" " + _vm._s(_vm.tooltipMessage) + " ")])]
          )
        : _vm.iconOnly
        ? _c(
            "v-btn",
            _vm._g(
              _vm._b(
                {
                  staticClass: "base-action-button__icon-button",
                  attrs: {
                    icon: "",
                    loading: _vm.isLoading,
                    disabled: _vm.isDisabled
                  }
                },
                "v-btn",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            ),
            [
              _vm.resolvedIconName
                ? _c("icon-svg", {
                    class: _vm.iconClassList,
                    attrs: {
                      name: _vm.resolvedIconName,
                      color: _vm.resolvedIconColor
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _c(
            "BaseButton",
            _vm._g(
              _vm._b(
                { attrs: { loading: _vm.isLoading, disabled: _vm.isDisabled } },
                "BaseButton",
                _vm.$attrs,
                false
              ),
              _vm.$listeners
            ),
            [
              _vm.resolvedIconName
                ? _c("icon-svg", {
                    class: _vm.iconClassList,
                    attrs: {
                      name: _vm.resolvedIconName,
                      color: _vm.resolvedIconColor
                    }
                  })
                : _vm._e(),
              _vm.label
                ? _c("span", { staticClass: "base-action-button__label" }, [
                    _vm._v(" " + _vm._s(_vm.label) + " ")
                  ])
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }